import upsell from "../upsell"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("basic_annual"),

  statusToTrack: "VISIT_CHECKOUT",

  onInit() {
    this.initUpsell()
  },
})
